import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setAppTitle as setAppTitleAction } from 'login-actions/layoutActions';
import DynamicUpdateComponent from './DynamicUpdateComponent';

interface AppTitleUpdaterProps {
  text: string | null;
  setAppTitle: (text: string) => any;
}

class AppTitleUpdater extends React.Component<AppTitleUpdaterProps, any> {
  render() {
    const { text, setAppTitle, children } = this.props;
    return (
      <DynamicUpdateComponent value={text} dispatchFn={setAppTitle}>
        {children}
      </DynamicUpdateComponent>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ setAppTitle: setAppTitleAction }, dispatch);

export default connect(
  null,
  mapDispatchToProps,
)(AppTitleUpdater);
